import { Stack } from '@mui/material';

export default function TomatoOrdersTable() {
  return <Stack>Će bude tabela</Stack>;
}
